document.addEventListener('DOMContentLoaded', () => {

  const variantData = JSON.parse(
    document.getElementById('MatrixVariants').textContent
  );

  let selectedBundle = 2;

  const cards = document.querySelectorAll('.matrix-card');

  cards.forEach(card => {

    card.addEventListener('click', () => {

      cards.forEach(c => c.classList.remove('active'));

      card.classList.add('active');

      const radio = card.querySelector('input');

      if (radio) {
        radio.checked = true;
        selectedBundle = parseInt(radio.value);
      }

    });

  });

  function getSelectedVariants() {

    const active = document.querySelector('.matrix-card.active');

    if (!active) return [];

    const selects = active.querySelectorAll('.matrix-color-select');

    const ids = [];

    selects.forEach(select => {

      const color = select.value;

      const variant = variantData.find(v => v.color === color);

      if (variant) {
        ids.push(variant.id);
      }

    });

    return ids;

  }

  window.matrixBundle = {
    getBundle: () => selectedBundle,
    getVariantIds: () => getSelectedVariants()
  };

});


